var _defs, _g, _g2, _g3, _g4, _g5, _g6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPiles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    zoomAndPan: "magnify",
    viewBox: "0 0 75 74.999997",
    height: 100,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a558795a18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9.960938 11.25 L 13.757812 11.25 L 13.757812 51.773438 L 9.960938 51.773438 Z M 9.960938 11.25 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a8424f78fd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 35.558594 11.25 L 39.359375 11.25 L 39.359375 51.449219 L 35.558594 51.449219 Z M 35.558594 11.25 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "530ac50468"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 60.515625 11.25 L 64.316406 11.25 L 64.316406 51.449219 L 60.515625 51.449219 Z M 60.515625 11.25 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "84d98a1f51"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5.898438 7.5 L 69.023438 7.5 L 69.023438 11.25 L 5.898438 11.25 Z M 5.898438 7.5 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5de27db000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 22.757812 11.25 L 26.558594 11.25 L 26.558594 51.773438 L 22.757812 51.773438 Z M 22.757812 11.25 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "454b87dccc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 48.039062 11.25 L 51.835938 11.25 L 51.835938 51.449219 L 48.039062 51.449219 Z M 48.039062 11.25 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a558795a18)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 9.960938 11.25 L 13.828125 11.25 L 13.828125 51.679688 L 9.960938 51.679688 Z M 9.960938 11.25 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a8424f78fd)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 35.558594 11.25 L 39.425781 11.25 L 39.425781 51.328125 L 35.558594 51.328125 Z M 35.558594 11.25 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#530ac50468)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 60.515625 11.25 L 64.382812 11.25 L 64.382812 51.328125 L 60.515625 51.328125 Z M 60.515625 11.25 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#84d98a1f51)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 5.898438 7.5 L 69.179688 7.5 L 69.179688 11.367188 L 5.898438 11.367188 Z M 5.898438 7.5 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5de27db000)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 22.757812 11.25 L 26.625 11.25 L 26.625 51.679688 L 22.757812 51.679688 Z M 22.757812 11.25 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#454b87dccc)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 48.039062 11.25 L 51.90625 11.25 L 51.90625 51.328125 L 48.039062 51.328125 Z M 48.039062 11.25 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPiles);
export default __webpack_public_path__ + "static/media/Piles.97e192e72e105050846079b97906b84f.svg";
export { ForwardRef as ReactComponent };